import { FunctionComponent, useEffect, useState } from "react";

import warrantyLabel from "../../assets/images/gesetzliche-gewaehrleistung.jpg";

const BILD_ALT =
  "Harmonisierte EU-Mitteilung: Mindestens zwei Jahre gesetzliche Gewährleistung der Vertragsmäßigkeit für Waren, die in der Europäischen Union verkauft werden. Verkäufer haften für jede Vertragswidrigkeit, die zum Zeitpunkt der Lieferung bestand, und müssen kostenlose Nachbesserung oder Ersatzlieferung, in bestimmten Fällen Preisminderung oder Erstattung des Kaufpreises anbieten.";

const LegalWarrantyLabel: FunctionComponent = () => {
  const [offen, setOffen] = useState(false);

  useEffect(() => {
    if (!offen) return;

    const beiTaste = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOffen(false);
    };

    document.addEventListener("keydown", beiTaste);
    return () => document.removeEventListener("keydown", beiTaste);
  }, [offen]);

  return (
    <>
      <button
        type="button"
        onClick={() => setOffen(true)}
        className="flex w-max items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-left text-sm text-gray-700 transition-colors hover:border-gray-400 hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
          className="shrink-0 text-blue-900"
        >
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <path d="M9 12l2 2 4-4" />
        </svg>
        <span>Mindestens 2 Jahre gesetzliche Gewährleistung</span>
        <span aria-hidden="true" className="text-gray-400">
          &rsaquo;
        </span>
      </button>

      {offen && (
        <div
          role="dialog"
          aria-modal="true"
          aria-label="Informationen zur gesetzlichen Gewährleistung in der Europäischen Union"
          onClick={() => setOffen(false)}
          className="fixed inset-0 z-[10000] flex items-start justify-center overflow-y-auto bg-black/70 p-4"
        >
          <button
            type="button"
            onClick={() => setOffen(false)}
            aria-label="Hinweis schließen"
            className="fixed right-4 top-4 z-[10001] flex h-10 w-10 items-center justify-center rounded-full bg-white text-2xl leading-none text-gray-900 shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
          >
            &times;
          </button>

          <div
            onClick={(e) => e.stopPropagation()}
            className="relative my-4 w-full max-w-[760px] sm:my-8"
          >
            <img
              src={warrantyLabel}
              alt={BILD_ALT}
              className="h-auto w-full rounded-md bg-white shadow-xl"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default LegalWarrantyLabel;
